import { render, staticRenderFns } from "./TestInvoice.vue?vue&type=template&id=2ad2f477&scoped=true"
import script from "./TestInvoice.vue?vue&type=script&lang=js"
export * from "./TestInvoice.vue?vue&type=script&lang=js"
import style0 from "./TestInvoice.vue?vue&type=style&index=0&id=2ad2f477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2f477",
  null
  
)

export default component.exports